"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultConfig = defaultConfig;
exports.editAliConfig = editAliConfig;
exports.editUMConfig = editUMConfig;
exports.getConfig = getConfig;
exports.listTextMessageRecord = listTextMessageRecord;
exports.resendTextMessage = resendTextMessage;
var _request = _interopRequireDefault(require("@/utils/request"));
function getConfig(params) {
  return (0, _request.default)({
    url: '/portal/system/textMsg/getTextMessageConfig',
    method: 'get',
    params: params
  });
}
function editAliConfig(data) {
  return (0, _request.default)({
    url: '/portal/system/textMsg/editAliConfig',
    method: 'post',
    data: data
  });
}
function editUMConfig(data) {
  return (0, _request.default)({
    url: '/portal/system/textMsg/editUMConfig',
    method: 'post',
    data: data
  });
}
function defaultConfig(data) {
  return (0, _request.default)({
    url: '/portal/system/textMsg/defaultConfig',
    method: 'post',
    data: data
  });
}
function listTextMessageRecord(data) {
  return (0, _request.default)({
    url: '/portal/system/textMsg/listTextMessageRecord',
    method: 'post',
    data: data
  });
}
function resendTextMessage(data) {
  return (0, _request.default)({
    url: '/portal/system/textMsg/resendTextMessage',
    method: 'post',
    data: data
  });
}